export const network = {
  _root: "/network",
  invite: {
    _root: "/invite",
    new: "/new",
    edit: "/:invitationId"
  },
  requestAccess: "/request-access"
};
